import { FormControl, FormGroup, Validators } from '@angular/forms';
import { emailValidator } from '../../../validators/email.validator';

export type SignInFormGroup = FormGroup<{
  email: FormControl<string>;
  password: FormControl<string>;
}>;

export function createSignInFormGroup(): SignInFormGroup {
  return new FormGroup({
    email: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required, emailValidator]
    }),
    password: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required]
    })
  });
}
